import React, { Fragment } from "react";

const CheckoutDropdown = ({ onChange }) => {
  return (
    <Fragment>
      <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
        Select Your Delivery Option
      </label>
      <select
        onChange={onChange}
        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
      >
        <option value="cci_lagosisland">
          Celebration Church Int'l - Lagos Island (free)
        </option>
        <option value="cci_ikeja">
          Celebration Church Int'l - Lagos Ikeja (free)
        </option>
        <option value="other">Other</option>
      </select>
    </Fragment>
  );
};

export default CheckoutDropdown;
